import styled from '@emotion/styled';

import { Button, theme, Typography } from '@/shared/design-system';

interface TransactionLoadErrorProps {
  message: string;
  onRetry?: () => Promise<unknown> | void;
}

const ErrorState = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing[12],
  minHeight: theme.spacing[80],
  textAlign: 'center',
}));

export const TransactionLoadError = ({ message, onRetry }: TransactionLoadErrorProps) => {
  const handleRetry = async () => {
    try {
      await onRetry?.();
    } catch {
      return;
    }
  };

  return (
    <ErrorState role="alert">
      <Typography variant="body2" color={theme.colors.text.secondary}>
        {message}
      </Typography>
      {onRetry ? (
        <Button size="sm" variant="outline" color="secondary" onClick={() => void handleRetry()}>
          Try again
        </Button>
      ) : null}
    </ErrorState>
  );
};
